/* eslint-disable no-unused-vars */
export enum EmployeesActionType {
  SET_EMPLOYEE = 'set_employee',
  GET_EMPLOYEES = 'get_employees',
  GET_EMPLOYEES_SUCCESS = 'get_employees_success',
  GET_EMPLOYEES_FAILURE = 'get_employees_failure',

  GET_EMPLOYEE_DEPENDENTS = 'get_employee_dependents',
  GET_EMPLOYEE_DEPENDENTS_SUCCESS = 'get_employee_dependents_success',
  GET_EMPLOYEE_DEPENDENTS_FAILURE = 'get_employee_dependents_failure',

  GET_EMPLOYEE_CONTACTS = 'get_employee_contacts',
  GET_EMPLOYEE_CONTACTS_SUCCESS = 'get_employee_contacts_success',
  GET_EMPLOYEE_CONTACTS_FAILURE = 'get_employee_contacts_failure',

  GET_EMPLOYEE_AUDITABLE = 'get_employee_auditable',
  GET_EMPLOYEE_AUDITABLE_SUCCESS = 'get_employee_auditable_success',
  GET_EMPLOYEE_AUDITABLE_FAILURE = 'get_employee_auditable_failure',

  GET_EMPLOYEE_PAY_STATEMENTS = 'get_employee_pay_statements',
  GET_EMPLOYEE_PAY_STATEMENTS_SUCCESS = 'get_employee_pay_statements_success',
  GET_EMPLOYEE_PAY_STATEMENTS_FAILURE = 'get_employee_pay_statements_failure',

  PATCH_EMPLOYEE_ACCESS = 'patch_employee_access',
  PATCH_EMPLOYEE_ACCESS_SUCCESS = 'patch_employee_access_success',
  PATCH_EMPLOYEE_ACCESS_FAILURE = 'patch_employee_access_failure',

  DISCONNECT_EMPLOYEE_ACCESS = 'disconnect_employee_access',
  DISCONNECT_EMPLOYEE_ACCESS_SUCCESS = 'disconnect_employee_access_success',
  DISCONNECT_EMPLOYEE_ACCESS_FAILURE = 'disconnect_employee_access_failure',
}
